import { Injectable } from '@angular/core';
import { HttpClient } from '../../../../../core/http/http-client';
import { ConfigService } from '../../../../../core/config.service';
import { LoggerService } from '../../../../../core/logger/logger.service';

export class DropReason {
	Id: number;
	Description: string;
}

@Injectable()
export class ReasonService {

	private url = this.configService.baseUrl + '/api/DeauthorizeSignal';
	private reasons: DropReason[];

	constructor(private http: HttpClient,
	            private configService: ConfigService,
	            private logger: LoggerService) {
	}

	getReasons(): Promise<DropReason[]> {
		if (this.reasons) {
			return Promise.resolve(this.reasons);
		} else {
			return this.loadReasons();
		}
	}

	private loadReasons(): Promise<DropReason[]> {
		return this.http.get(this.url)
			.toPromise()
			.then(res => {
				this.reasons = res.json();
				return this.reasons;
			}).catch(error => {
				this.logger.error(error);
				return null;
			});
	}
}